import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { AppLogoIcon } from '@/assets/icons';
import { Button } from '@/components/ui/button';

export function NotFound() {
    const { t } = useTranslation();

    return (
        <div className="flex min-h-screen flex-col items-center justify-center gap-6 px-4 text-center">
            <AppLogoIcon aria-hidden className="size-10" />
            <p className="text-6xl font-bold tracking-tight text-muted-foreground">
                404
            </p>
            <h1 className="text-2xl font-semibold tracking-tight">
                {t('notFound.title')}
            </h1>
            <p className="max-w-md text-muted-foreground">
                {t('notFound.description')}
            </p>
            <Button asChild>
                <Link to="/">{t('notFound.backHome')}</Link>
            </Button>
        </div>
    );
}
